<aside class="platform-sidebar" [class.visible]="isVisible()" [class.pinned]="isPinned()">
  <div class="sidebar-header">
    <div class="brand">
      <span class="brand-name">Alphastar</span>
    </div>
    <div class="header-actions">
        <button class="pin-button" [class.active]="isPinned()" (click)="pin.emit()"
        [title]="isPinned() ? 'Unpin sidebar' : 'Pin sidebar'">
        <i class="pi pi-thumbtack"></i>
      </button>
      @if (!isPinned()) {
      <button class="close-button" (click)="sidebarClosed.emit()">
        <i class="pi pi-times"></i>
      </button>
      }
    </div>
  </div>

  <div class="search-container-sidebar">
    <div class="search-box">
      <input type="text" placeholder="Search" [(ngModel)]="searchQuery" />
      <i class="pi pi-search"></i>
    </div>
  </div>

  <nav class="sidebar-nav">
    @for (item of filteredMenuItems(); track item.label) {
    <div class="nav-group">
      @if (item.children && item.children.length > 0) {
      <div class="nav-item has-submenu" [class.expanded]="isExpanded(item.label)"
        (click)="toggleSubmenu(item.label, $event, filteredMenuItems())">
        <div class="nav-item-content">
          @if (isSvgIcon(item.icon)) {
          <img [src]="item.icon" class="nav-icon-svg" alt="" />
          } @else {
          <i [class]="item.icon"></i>
          }
          <span class="label">{{ item.label }}</span>
        </div>
        <i class="pi pi-chevron-down submenu-arrow"></i>
      </div>
      @if (isExpanded(item.label)) {
      <div class="submenu">
        @for (child of item.children; track child.label) {
        @if (!child.hideInSidebar) {
        @if (hasVisibleChildren(child.children)) {
        <div class="submenu-item has-submenu nested-submenu" [class.expanded]="isExpanded(child.label)"
          (click)="toggleSubmenu(child.label, $event, item.children)">
          <div class="submenu-item-content">
            @if (child.icon) {
            @if (isSvgIcon(child.icon)) {
            <img [src]="child.icon" class="nav-icon-svg" alt="" />
            } @else {
            <i [class]="child.icon"></i>
            }
            }
            <span class="label">{{ child.label }}</span>
          </div>
          <i class="pi pi-chevron-down submenu-arrow"></i>
        </div>
        @if (isExpanded(child.label)) {
        <div class="submenu nested">
          @for (grandchild of child.children; track grandchild.label) {
          @if (!grandchild.hideInSidebar) {
          <a [routerLink]="grandchild.route" [queryParams]="grandchild.queryParams" routerLinkActive="active"
            [routerLinkActiveOptions]="linkActiveOptions()" class="submenu-item" (click)="sidebarClosed.emit()">
            <div class="submenu-item-content">
              @if (grandchild.icon) {
              @if (isSvgIcon(grandchild.icon)) {
              <img [src]="grandchild.icon" class="nav-icon-svg" alt="" />
              } @else {
              <i [class]="grandchild.icon"></i>
              }
              }
              <span class="label">{{ grandchild.label }}</span>
            </div>
          </a>
          }
          }
        </div>
        }
        } @else {
        <a [routerLink]="child.route" [queryParams]="child.queryParams" routerLinkActive="active"
          [routerLinkActiveOptions]="linkActiveOptions()" class="submenu-item" (click)="sidebarClosed.emit()">
          <div class="submenu-item-content">
            @if (child.icon) {
            @if (isSvgIcon(child.icon)) {
            <img [src]="child.icon" class="nav-icon-svg" alt="" />
            } @else {
            <i [class]="child.icon"></i>
            }
            }
            <span class="label">{{ child.label }}</span>
          </div>
        </a>
        }
        }
        }
      </div>
      }
      } @else {
      @if (item.isButton) {
      <app-custom-button class="sidebar-action-btn" [routerLink]="item.route" [queryParams]="item.queryParams"
        color="primary" (onClick)="sidebarClosed.emit()">
        <div class="nav-item-content">
          @if (isSvgIcon(item.icon)) {
          <img [src]="item.icon" class="nav-icon-svg" alt="" />
          } @else {
          <i [class]="item.icon"></i>
          }
          <span class="label">{{ item.label }}</span>
        </div>
      </app-custom-button>
      } @else {
      <a [routerLink]="item.route" [queryParams]="item.queryParams" routerLinkActive="active"
        [routerLinkActiveOptions]="linkActiveOptions()" class="nav-item" (click)="sidebarClosed.emit()">
        <div class="nav-item-content">
          @if (isSvgIcon(item.icon)) {
          <img [src]="item.icon" class="nav-icon-svg" alt="" />
          } @else {
          <i [class]="item.icon"></i>
          }
          <span class="label">{{ item.label }}</span>
        </div>
      </a>
      }
      }
    </div>
    @if (item.divider) {
    <div class="sidebar-divider"></div>
    }
    }
  </nav>

  <div class="sidebar-footer">
    <div class="footer-nav">
      @for (item of config()?.footerItems; track item.label) {
      <a [routerLink]="item.label === 'Logout' ? null : item.route"
        [queryParams]="item.label === 'Logout' ? null : item.queryParams" routerLinkActive="active" class="footer-item"
        (click)="handleFooterClick(item, $event)">
        @if (isSvgIcon(item.icon)) {
        <img [src]="item.icon" class="nav-icon-svg" alt="" />
        } @else {
        <i [class]="item.icon"></i>
        }
        <span class="label">{{ item.label }}</span>
      </a>
      }
    </div>
    <!-- <div class="status-indicator">
      <span class="dot"></span>
      <span>System Online</span>
    </div> -->
  </div>
</aside>